/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Input/view.blocks to change it.
import "DesignSystem/Fonts/Inter-300.module.css"
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Input({
  children,
  viewPath = "/DesignSystem/Input",
  backgroundColor = "#f2f2f2",
  borderBottomLeftRadius = 8,
  borderBottomRightRadius = 8,
  borderTopLeftRadius = 8,
  borderTopRightRadius = 8,
  autoComplete = "on",
  autoCapitalize,
  autoFocus,
  className,
  disabled,
  fontFamily = "Inter",
  fontSize = 13,
  onBlur,
  onChange,
  onFocus,
  onKeyUp,
  marginRight = 0,
  marginLeft = 0,
  marginTop = 0,
  marginBottom = 0,
  paddingBottom = 16,
  paddingLeft = 16,
  paddingRight = 16,
  paddingTop = 16,
  placeholder,
  innerRef,
  textTransform = "none",
  type = "text",
  textAlign = "left",
  value,
  width = 200,
  height = "auto",
  isInvalid,
  isDisabled,
  isShowingInvalidMessage,
  invalidMessage = ""
  
}) {
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<input
 type={
                type === 'phone' ? 'tel' :
                type === 'secure' ? 'password' : type}
inputMode={type === 'number' || type === 'phone'? "numeric" : undefined}
pattern={type === 'number' || type === 'phone'? "[0-9]*" : undefined}
  data-testid="Input.Input:1"
  data-view-path={viewPath}
 autoComplete={autoComplete}
 autoFocus={autoFocus}
 disabled={disabled}
 onBlur={onBlur}
 onChange={(e) => onChange && onChange(e, e.target.value)}
 onFocus={onFocus}
 onKeyUp={onKeyUp}
 placeholder={placeholder}
 ref={innerRef}
 value={value}
 style={{'--bc-1-56VAy': backgroundColor,'--bblr-2-56VAy': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-3-56VAy': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-4-56VAy': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-5-56VAy': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--c-7-56VAy': dtColorsNeutral900,'--ff-8-56VAy': fontFamily,'--fs-9-56VAy': typeof fontSize === 'number' ? `${fontSize}px` : fontSize,'--mr-10-56VAy': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--ml-11-56VAy': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mt-12-56VAy': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-13-56VAy': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--pb-14-56VAy': typeof paddingBottom === 'number' ? `${paddingBottom}px` : paddingBottom,'--pl-15-56VAy': typeof paddingLeft === 'number' ? `${paddingLeft}px` : paddingLeft,'--pr-16-56VAy': typeof paddingRight === 'number' ? `${paddingRight}px` : paddingRight,'--pt-17-56VAy': typeof paddingTop === 'number' ? `${paddingTop}px` : paddingTop,'--tt-18-56VAy': textTransform,'--ta-19-56VAy': textAlign,'--w-20-56VAy': typeof width === 'number' ? `${width}px` : width,'--h-21-56VAy': typeof height === 'number' ? `${height}px` : height,'--bc-6-56VAy': isInvalid ? "rgba(224,51,51, 0.75)" : dtColorsNeutral300}}
 className={`views-capture ${className} ${styles.Input1}`}
/>
<fromFlow.When is={isShowingInvalidMessage}>
<span
  data-testid="Input.Text"
  data-view-path={viewPath}
 className={`views-text ${styles.Text}`}
>
{invalidMessage}
</span>
</fromFlow.When>
{children}
</React.Fragment>)
}